<template>
  <v-container>
    <h2 class="mb-3">{{$t('leave_category')}}</h2>
    <v-dialog v-model="addLeaveDialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col>
            <v-btn right color="primary" dark class="mb-2" v-on="on" @click="addedItem()">{{$t('add_category')}}</v-btn>
          </v-col>
          <v-col md="6" class="pt-0">
            <v-text-field hide-details :label="$t('find_a_category')" :rules="[validator.alfaNumberNotRequired]" prepend-inner-icon="mdi-magnify" single-line
              v-model="search"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('add_category')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('code_leave')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.code"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('leave_name_id')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.name_id"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('leave_name_en')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="addItem.name_en"></v-text-field>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    label="Remark Indonesia"
                    v-model="addItem.remark_id"
                  ></v-text-field>
                </v-col>-->
                <v-col cols="12" sm="12" md="12">
                  <v-text-field   :rules="[...rules, validator.alfaNumberNotRequired]" :label="$t('remark')" v-model="addItem.remark_en"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select :items="appType" :label="$t('approval_type')" :rules="rules" v-model="addItem.approval_type"
                    item-text="name" item-value="id"></v-select>
                </v-col>
                <!-- <v-col class="d-flex" cols="12" md="6" sm="12">
                  <v-switch :label="$t('deductible')" inset class="my-0 py-0" v-model="addItem.is_balance_deduction"
                    color="rgb(0,150,45)"></v-switch>
                </v-col> -->
                <v-col cols="12" sm="12" md="12">
                  <v-checkbox v-model="addItem.is_attachment" :label="$t('mandatory_upload_file')"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn :loading="loading" color="primary" @click="addLeave(addItem)" :disabled="!valid">{{$t('save')}}</v-btn >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editLeaveDialog" max-width="500px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('edit_category')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('code_leave')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.code"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('leave_name_id')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.name_id"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('leave_name_en')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.name_en"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Remark Indonesia"
                  v-model="editItem.remark_id"
                ></v-text-field>
              </v-col>-->
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('remark')" :rules="[...rules, validator.alfaNumberNotRequired]" v-model="editItem.remark_en"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select :items="appType" :label="$t('approval_type')" v-model="editItem.approval_type" item-text="name"
                  item-value="id"></v-select>
              </v-col>
              <!-- <v-col class="d-flex" cols="12" md="6" sm="12">
                <v-switch :label="$t('deductible')" inset class="my-0 py-0" v-model="editItem.is_balance_deduction"
                  color="rgb(0,150,45)"></v-switch>
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <v-checkbox v-model="editItem.is_attachment" :label="$t('mandatory_upload_file')"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn color="primary" :loading="loading" dark @click="editLeave(editItem)">{{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteLeaveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_category')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteLeaveDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteLeave(itemToDelete.id)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :search="search" :items="leave_list" :headers="headers" class="elevation-1 mt-3" :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:item.approval_type="{ item }">
        <div v-if="item.approval_type == 1">{{$t('1_layer')}}</div>
        <div v-else>{{$t('2_layer')}}</div>
      </template>
      <!-- <template v-slot:item.is_balance_deduction="{ item }">
        <div v-if="item.is_balance_deduction === true">
          <v-switch inset color="success" value input-value="true" disabled></v-switch>
        </div>
        <div v-else>
          <v-switch inset color="error" disabled></v-switch>
        </div>
      </template> -->
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
        <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.is_attachment="{ item }">
        <div v-if="item.is_attachment == true">{{$t('mandatory')}}</div>
        <div v-else>{{$t('not_mandatory')}}</div>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "leave",
  data() {
    return {
      headers: [
        { text: this.$i18n.t('code_leave'), value: "code" },
        { text: this.$i18n.t('leave_name_id'), value: "name_id" },
        { text: this.$i18n.t('leave_name_en'), value: "name_en" },
        // { text: "Remark Indonesia", value: "remark_in" },
        { text: this.$i18n.t('remark'), value: "remark_en" },
        { text: this.$i18n.t('attachment'), value: "is_attachment" },
        { text: this.$i18n.t('approval_type'), value: "approval_type" },
        // { text: this.$i18n.t('deductible'), value: "is_balance_deduction" },
        { text: this.$i18n.t('manage'), value: "action" },
      ],
      appType: [{
        name: this.$i18n.t('1_layer'),
        id: 1,
      },
      {
        name: this.$i18n.t('2_layer'),
        id: 2,
      }],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      leave_list: [],
      search: "",
      addItem: {
        code: "",
        name_id: "",
        name_en: "",
        remark_id: null,
        remark_en: "",
        is_attachment: false,
        approval_type: "",
        // is_balance_deduction: null,
        companyId: "",
      },
      editItem: {
        code: "",
        name_id: "",
        name_en: "",
        remark_id: null,
        remark_en: "",
        is_attachment: "",
        approval_type: "",
        // is_balance_deduction: null,
        companyId: "",
      },
      itemToDelete: {
        id: "",
        companyId: "",
      },
      leave: [{
        id: "",
        companyId: "",
      }],
      is_attachment: [{
        name: this.$i18n.t('mandatory'),
        id: true,
      },
      {
        name: this.$i18n.t('not_mandatory'),
        id: false,
      }],
      addLeaveDialog: false,
      deleteLeaveDialog: false,
      editLeaveDialog: false,
      loading: false,
      editedIndex: -1,
      rules: [(v) => !!v || `${this.$i18n.t('required')}`],
      valid: true,
    };
  },
  methods: {
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    addedItem() {
      this.addLeaveDialog = true;
    },
    editedItem(item) {
      this.editedIndex = this.leave.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.editLeaveDialog = true;
      this.getLeaveCategoryList();
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteLeaveDialog = true;
    },
    close() {
      this.addLeaveDialog = false;
      this.editLeaveDialog = false;
      this.deleteLeaveDialog = false;
    },
    async getLeaveCategoryList() {
      this.leave_list = await this.$store.dispatch('getLeaveCategory', { companyId: this.company_id })
    },
    async addLeave(item) {
      this.loading = true;
      const result = await this.$store.dispatch('saveLeaveCategory', {
        code: item.code,
        name_id: item.name_id,
        name_en: item.name_en,
        remark_id: item.remark_id,
        remark_en: item.remark_en,
        is_attachment: item.is_attachment,
        approval_type: item.approval_type,
        // is_balance_deduction: item.is_balance_deduction,
        companyId: this.company_id,
      })
      this.loading = false;
      if (result) {
        this.addLeaveDialog = false;
        this.getLeaveCategoryList();
        this.showMessage('success', this.$i18n.t('alert_save'))
      } else {
        this.addLeaveDialog = true;
      }
    },
    async editLeave(item) {
      this.loading = true;
      const result = await this.$store.dispatch('editLeaveCategory', {
        code: item.code,
        name_id: item.name_id,
        name_en: item.name_en,
        remark_id: item.remark_id,
        remark_en: item.remark_en,
        is_attachment: item.is_attachment,
        id: item.id,
        approval_type: item.approval_type,
        // is_balance_deduction: item.is_balance_deduction,
        companyId: this.company_id
      })
      this.loading = false;
      if (result)  {
        this.editLeaveDialog = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.getLeaveCategoryList();
      } else {
        this.editLeaveDialog = true;
      }
    },
    async deleteLeave(id) {
      const result = await this.$store.dispatch('deleteLeaveCategory', {id})
      if (result) {
        this.deleteLeaveDialog = false;
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.getLeaveCategoryList();
      }
    },
  },
  created() {
    this.getLeaveCategoryList();
  },
  watch: {
    dialog() {
      this.changeNUserStatus(this.editedItem.status);
      this.changeUserRole(this.editedItem.role);
    },
    addLeaveDialog() {
      if (this.$refs.addForm) {
        this.$refs.addForm.reset();
      }
    },
  },
};
</script>
